import React from "react";
import Carousel from 'react-bootstrap/Carousel';
import slider1 from "../../assets/images/banner-slide-1.jpg";
import slider2 from "../../assets/images/banneslider-2.jpg";



const BannerSlider = () => {
    return (
        <>
            <Carousel fade>
            <Carousel.Item>
                    <div className="slider-wigit-banner">
                        <img src={slider2} width="100%" alt="" />
                    </div>
                </Carousel.Item>
                <Carousel.Item>
                    <div className="slider-wigit-banner">
                        <img src={slider1} width="100%" alt="" />
                        <Carousel.Caption className="slider-content-wap">
                            <h3>GomyFood Delivery</h3>
                            <p class="mb-0 txt-bn-color"><i>Idli, Vada, Dosa</i></p><p><i>Yummy Taste With Gomy's Care!</i></p>
                            <div className="banner-btm-bottom mt-md-5">
                                <button type="button" class="btn btn-theme banner-shop-btn">Shop Now</button>
                            </div>
                        </Carousel.Caption>
                    </div>
                </Carousel.Item>
         
            </Carousel>
        </>
    )
}
export default BannerSlider;